module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion.a5942c7d4cd196e6c2300bd0a34ad052.png";